"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = void 0;
/**
 * Helps ensure exhaustive handling of enums at compile time in, e.g., switch statements.
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#the-never-type
 */
const assertNever = (argument, errorMessage) => {
    throw new Error(errorMessage);
};
exports.assertNever = assertNever;
